<template>
    <div
        class="product-list-option"
        :class="{
            'color-inline-btn-group-input': option.attribute.isColor
        }"
    >
        <v-item-group
            class="d-flex flex-wrap"
            :model-value="modelValue"
            @update:model-value="onChange($event)"
            mandatory
        >
            <v-item
                v-for="(optVal, index) in option.groupValues"
                :key="`option-item-${option.attribute.uid}`"
                :value="optVal.value.uid"
                #default="{ isSelected, toggle, value }"
            >
                <template
                    v-if="option.attribute.isColor"
                >
                    <ColorImageButton
                        v-if="optVal.value.svg"
                        :key="`option-color-image-${index}`"
                        :model-value="isSelected"
                        :image="optVal.value.svg"
                        :aria-label="optVal.value.name"
                        :rounded="false"
                        :inner-circle="true"
                        @click="toggle"
                    ></ColorImageButton>
                    <ColorSwatchButton
                        v-else
                        :key="`option-color-swatch-${index}`"
                        variant="text"
                        :model-value="isSelected"
                        :color="optVal.value.colors"
                        :aria-label="optVal.value.name"
                        :rounded="false"
                        @click="toggle"
                    ></ColorSwatchButton>
                </template>
                <template
                    v-else
                >
                    <!-- TODO: This will have non-color options TBD -->
                </template>
            </v-item>
        </v-item-group>
    </div>
</template>

<script lang="ts" setup>
    import type {
        ProductAttrsGroupOption
    } from '~/types';
    import ColorSwatchButton from '~/components/color/ColorSwatchButton/ColorSwatchButton.vue';
    import ColorImageButton from '~/components/color/ColorImageButton/ColorImageButton.vue';

    const props = defineProps<{
        modelValue: string;
        option: ProductAttrsGroupOption;
    }>();

    const emit = defineEmits<{
        'update:modelValue': [value: string];
        'options-model': [value: [uidAtt: string, uidAttVal: string, optionIndex: number]];
    }>();

    async function onChange(
        optionUid: string
    ): Promise<void> {
        const optionIndex = props.option.groupValues.findIndex((val) => val.value.uid === optionUid);
        const option = props.option.groupValues[optionIndex];

        if (option) {
            const uidAtt = props.option.attribute.uid;
            const uidAttVal = option.value.uid;
            emit('options-model', [uidAtt, uidAttVal, optionIndex]);
            emit('update:modelValue', uidAttVal);
        }
    }
</script>

<style lang="scss">
.product-list-option {
    --color-inline-btn-gap: 0.4rem;
    --color-inline-btn-padding: 3px;
    --color-inline-btn-size: 30px;
}
</style>
